import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=be4219fe&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=be4219fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4219fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be4219fe')) {
      api.createRecord('be4219fe', component.options)
    } else {
      api.reload('be4219fe', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=be4219fe&scoped=true&", function () {
      api.rerender('be4219fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LzBGwioT68KP/JS/comp/PopupBox.vue"
export default component.exports